import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-archive",
  templateUrl: "./med-icon-archive.component.html",
})
export class MedIconArchiveComponent extends SvgMixinComponent {}
